"use client"

import type React from "react"

import { motion } from "framer-motion"
import { cn } from "@/lib/utils"

type Props = {
  children: React.ReactNode
  className?: string
  variant?: "light" | "dark" | "outline"
}

export function SectionLabel({ children, className, variant = "outline" }: Props) {
  const base = "inline-flex items-center rounded-full px-4 py-1.5 text-sm font-medium tracking-wide"
  const styles =
    variant === "light"
      ? "bg-(--mmi-pill-bg) text-(--mmi-pill-fg)"
      : variant === "dark"
        ? "bg-transparent border border-white text-white"
        : "bg-white border border-black text-black"
  return (
    <motion.span
      initial={{ y: 8, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.6 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className={cn(base, styles, className)}
      aria-hidden="true"
    >
      {children}
    </motion.span>
  )
}
